<template>
  <div>
    <v-row class="contact_block">
      <v-col align="center">
          <h2 class="contact_title1">{{ $t("contact.title") }}</h2>
          <p class="contact_title2">{{ $t("contact.subtitle") }}<a href="http://www.ebmtech.com/index.php" target="_blank" style="text-decoration:none;">{{ $t("contact.ebm") }}</a></p>
      </v-col>
    </v-row>
    <div class="form_block">
    <FormulateForm
    v-if="lang == 'en'"
    class="login-form"
    v-model="formValues"
    @submit="submitForm"
    name="contactform"
    >
    <h2 class="form-title">{{ $t("contact.info") }}</h2>
    <div class="double-wide">
    <FormulateInput
    name="name"
    type="text"
    placeholder="Name*"
    validation="required"
    />
    <FormulateInput
    name="email"
    type="email"
    placeholder="Email*"
    validation="required|email"
    />
    </div>
    <div class="double-wide">
    <FormulateInput
    name="telephone"
    type="text"
    placeholder="Phone number"
    />
    <FormulateInput
    name="product"
    type="select"
    :options="{TheFHRAPP: 'The FHR APP'}"
    placeholder="Image upload"
    />
    </div>
    <FormulateInput
    type="textarea"
    name="message"
    placeholder="Message"
    />
    <FormulateInput
    type="submit"
    label="Submit"
    />
    <!-- <pre
    class="code"
    v-text="formValues"
    /> -->
    </FormulateForm>
    <FormulateForm
    v-else
    class="login-form"
    v-model="formValues"
    @submit="submitForm"
    name="contactform"
    >
    <h2 class="form-title">留下您的聯絡方式</h2>
    <div class="double-wide">
    <FormulateInput
    name="name"
    type="text"
    placeholder="姓名*"
    validation="required"
    />
    <FormulateInput
    name="email"
    type="email"
    placeholder="電子郵件*"
    validation="required|email"
    />
    </div>
    <div class="double-wide">
    <FormulateInput
    name="telephone"
    type="text"
    placeholder="電話"
    />
    <FormulateInput
    name="product"
    type="select"
    :options="{光碟超快遞: '光碟超快遞'}"
    placeholder="影像上傳"
    />
    </div>
    <FormulateInput
    type="textarea"
    name="message"
    validation="required"
    placeholder="訊息內容"
    />
    <FormulateInput
    type="submit"
    label="送出"
    />
    <!-- <pre
    class="code"
    v-text="formValues"
    /> -->
    </FormulateForm>
    </div>
    <v-snackbar
      v-model="snackbar"
      color="success"
      outlined
    >
      {{ $t("contact.success") }}
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data:function(){
  const lang = localStorage.getItem('lang')
  return{
      lang:lang,
      snackbar: false,
      formValues: {
        createDate: '',
      }
    }
  },
  methods:{
      async submitForm(){
        this.formValues.product ='The FHR APP'
        const saveDate = new Date();
        let month =saveDate.getMonth();
        let date = saveDate.getDate();
        let hours = saveDate.getHours();
        let minutes = saveDate.getMinutes();
        let seconds = saveDate.getSeconds();
        month++;
        month = ("0" + month).slice(-2);
        date = ("0" + date).slice(-2);
        hours = ("0" + hours).slice(-2);
        minutes = ("0" + minutes).slice(-2);
        seconds = ("0" + seconds).slice(-2);
        this.formValues.createDate = saveDate.getFullYear()+ "-" + month+ '-'+ date+'T'+ hours+':'+ minutes+':'+ seconds
        console.log("form",this.formValues);
        
        //calling post request to api 
        try {
              const res = await axios.post('UserContacts',this.formValues)
              this.snackbar = true
              console.log(res);
              this.$formulate.reset('contactform')
              this.clearForm();
        } 
        catch (err) {
              this.$formulate.handle(err, 'contactform')
        }
      },
      clearForm(){
        this.formValues.name ='';
        this.dropboxForm.product ='';
        this.formValues.telephone ='';
        this.dropboxForm.message ='';
        this.formValues.email ='';
        this.dropboxForm.createDate =''
      },
  }
}
</script>

<style scoped>
.form_block{
  margin-left: 239px;
  margin-right: 239px;
}
.contact_title3{
    font-size: 20px;
    color: #2A2F35;
}
.contact_title2{
    margin-top: 13px;
    font-size: 20px;
    color: #2A2F35;
}
.contact_title1{
    color: #2A2F35;
    margin-top: 50px;
}
.contact_block{
    /* height: 207px; */
    background: #F8F8F8 0% 0% no-repeat padding-box;
}
.login-form {
  margin:auto;
  /* margin-left: 280px; */
  padding: 2em;
  /* border: 1px solid #a8a8a8; */
  border-radius: .5em;
  width: 100%;
  box-sizing: border-box;
}
.form-title {
  margin-bottom: 1em;
  color: #012E81;
}
.login-form::v-deep .formulate-input .formulate-input-element {
  max-width: none;
}
.login-form::v-deep .formulate-input .formulate-input-element--textarea textarea{
  height: 171px;
}
.login-form::v-deep .formulate-input button{
    border: 1px solid #00beff;
    background-color: #00beff;
    width: 108px;
    height: 38px;
    border-radius: 0em;
}
.login-form::v-deep .formulate-input input:focus{
  color: #00beff;
}
.login-form::v-deep .formulate-input button:hover{
  background-color: #2A2F35;
}
.login-form::v-deep .formulate-input-element--submit--label{
    margin: auto;
}
@media screen and (max-width: 960px){
  .form_block{
  margin-left: 15px;
  margin-right: 15px;
}
}
@media (min-width: 420px) {
  .double-wide {
    display: flex;
  }
  .double-wide .formulate-input {
    flex-grow: 1;
    width: calc(50% - .5em);
  }
  .double-wide .formulate-input:first-child {
    margin-right: .5em;
  }
  .double-wide .formulate-input:last-child {
    margin-left: .5em;
  }
}
@media (max-width: 464px){
  .form_block{
  margin-left: 0px;
  margin-right: 0px;
}
.contact_title2{
    font-size: 16px;
    margin-left: 12px;
    margin-right: 12px;
}
}
</style>